export var popupWindowNames = /*#__PURE__*/ function(popupWindowNames) {
    popupWindowNames["SocialLogin"] = "SocialLogin";
    popupWindowNames["LinkedinShare"] = "LinkedinShare";
    return popupWindowNames;
}({});
